import CaicCellStepper from './src/CaicCellStepper.vue'
const CellStepper = {
  install: function (Vue) {
    Vue.component(CaicCellStepper.name, CaicCellStepper)
  }
}
export default CellStepper



// WEBPACK FOOTER //
// ./src/cell-stepper/index.js